import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/auth.css";

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login, error, user, isLoading } = useAuth();

  if (!isLoading && user) return <Navigate to="/" replace />;
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loginLoading, setLoginLoading] = useState(false);
  const [formError, setFormError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormError("");
    setLoginLoading(true);

    try {
      await login(formData.email, formData.password);
      navigate("/");
    } catch (err: any) {
      setFormError(err.message);
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div style={{ textAlign: "center", marginBottom: 8 }}>
          <img src="/logo.png" alt="E.H.C Logistics" style={{ height: 64, objectFit: "contain" }} />
        </div>
        <h2>Login</h2>

        {(formError || error) && (
          <div className="error-message">{formError || error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your@email.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="••••••••"
            />
          </div>

          <button type="submit" disabled={loginLoading} className="submit-btn">
            {loginLoading ? "Logging in..." : "Login"}{" "}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            <a href="/forgot-password" style={{ color: "#667eea", fontSize: 13 }}>Forgot your password?</a>
          </p>
          <p style={{ marginTop: 8, color: '#64748b', fontSize: 13 }}>
            New customer?{' '}
            <a href="/register" style={{ color: '#667eea', fontWeight: 600 }}>Create a free account</a>
          </p>
          <p style={{ marginTop: 8 }}>
            <a href="/track" style={{ color: "#3b82f6", fontSize: 13 }}>
              📦 Track a shipment without logging in →
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
